/* Side-effect module: imported FIRST in main.tsx so the API auth wrapper is on
   window.fetch before any other module (or its import-time code) can fetch. */
import { installApiAuthFetch } from './apiAuthFetch';

installApiAuthFetch();
